import { useLingui } from '@lingui/react/macro';
import { Label } from '@repo/videa-components/src/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/videa-components/src/ui/select';
import { Controller, useFormContext } from 'react-hook-form';

import type { ReferralFormValues } from '../../types';

export const DateOfBirthField = () => {
  const { t } = useLingui();
  const {
    control,
    formState: { defaultValues },
  } = useFormContext<ReferralFormValues>();

  const days = Array.from({ length: 31 }, (_, i) =>
    (i + 1).toString().padStart(2, '0'),
  );
  const months = [
    { value: '01', label: t`January` },
    { value: '02', label: t`February` },
    { value: '03', label: t`March` },
    { value: '04', label: t`April` },
    { value: '05', label: t`May` },
    { value: '06', label: t`June` },
    { value: '07', label: t`July` },
    { value: '08', label: t`August` },
    { value: '09', label: t`September` },
    { value: '10', label: t`October` },
    { value: '11', label: t`November` },
    { value: '12', label: t`December` },
  ];
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 100 }, (_, i) => currentYear - i);

  return (
    <div className="vai-space-y-1">
      <Label htmlFor="patientDOB" className="vai-text-sm">
        {t`Date of Birth`}
        <span className="vai-text-red-500">*</span>
      </Label>
      <div className="vai-grid vai-grid-cols-3 vai-gap-2">
        <Controller
          name="patientDOBDay"
          control={control}
          rules={{ required: true }}
          render={({ field }) => {
            return (
              <Select
                onValueChange={field.onChange}
                value={field.value?.toString()}
                disabled={!!defaultValues?.patientDOBDay}
              >
                <SelectTrigger className="vai-h-8 vai-text-sm">
                  <SelectValue placeholder={t`Day`} />
                </SelectTrigger>
                <SelectContent>
                  {days.map((day) => (
                    <SelectItem key={day} value={day}>
                      {day}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            );
          }}
        />

        <Controller
          name="patientDOBMonth"
          control={control}
          rules={{ required: true }}
          render={({ field }) => {
            return (
              <Select
                onValueChange={field.onChange}
                value={field.value?.toString()}
                disabled={!!defaultValues?.patientDOBMonth}
              >
                <SelectTrigger className="vai-h-8 vai-text-sm">
                  <SelectValue placeholder={t`Month`} />
                </SelectTrigger>
                <SelectContent>
                  {months.map((month) => (
                    <SelectItem key={month.value} value={month.value}>
                      {month.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            );
          }}
        />

        <Controller
          name="patientDOBYear"
          control={control}
          rules={{ required: true }}
          render={({ field }) => {
            return (
              <Select
                onValueChange={field.onChange}
                value={field.value?.toString()}
                disabled={!!defaultValues?.patientDOBYear}
              >
                <SelectTrigger className="vai-h-8 vai-text-sm">
                  <SelectValue placeholder={t`Year`} />
                </SelectTrigger>
                <SelectContent>
                  {years.map((year) => (
                    <SelectItem key={year} value={year.toString()}>
                      {year}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            );
          }}
        />
      </div>
    </div>
  );
};
